import React, { useState } from 'react';
import { Card, Button, Space, Typography, Layout, Modal, Form, Input } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';

const { Title, Text } = Typography;
const { Content } = Layout;

const About = () => {
  // 1. 用useState管理弹窗显示/隐藏
  const [isModalOpen, setIsModalOpen] = useState(false);
  // 2. 用useState管理作者信息（后续可替换为接口数据）
  const [authorInfo, setAuthorInfo] = useState({
    name: 'xinxin',
    intro: '这个人很神秘，什么也没留下。', 
    email: '1092306675@qq.com',
    techStack: '暂无',
    hobbies: '动画',
    avatarUrl: 'https://imgchr.com/i/pZ8dsVU', // 头像URL
    detailIntro: '欢迎来到我的博客！请登陆后完善您的个人信息！', // 更详细的介绍
    github: '#',
    personalLink: '#'
  });
  // 3. 获取Form实例（用于表单操作）
  const [form] = Form.useForm();

  // 打开弹窗：初始化表单数据
  const handleEdit = () => {
    setIsModalOpen(true);
    // 把当前作者信息同步到表单
    form.setFieldsValue(authorInfo);
  };

  // 关闭弹窗
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // 提交表单：保存编辑后的信息
  const handleSubmit = (values) => {
    // 实际场景：调用接口保存数据
    setAuthorInfo(values);
    setIsModalOpen(false);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader />

      <Content style={{ padding: '50px 20px', display: 'flex', justifyContent: 'center' }}>
        <Card
          style={{ width: 800 }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '30px', padding: '20px' }}>
            {/* 左侧：头像和签名 */}
            <div style={{ textAlign: 'center', flexShrink: 0 }}>
              <img
                src={authorInfo.avatarUrl} 
                alt="作者头像"
                style={{ width: 120, height: 120, borderRadius: '50%', marginBottom: 10 }}
              />
              <Text type="secondary" style={{ display: 'block' }}>{authorInfo.intro}</Text>
            </div>

            {/* 右侧：个人信息 */}
            <div style={{ flex: 1 }}>
              <Title level={3}>Hi！我是 {authorInfo.name}</Title>
              
              {/* 信息表格 */}
              <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '15px 0', padding: '20px 0' }}>
                <Text strong>邮箱</Text>
                <Text>{authorInfo.email}</Text>

                <Text strong>技术栈</Text>
                <Text>{authorInfo.techStack}</Text>

                <Text strong>兴趣爱好</Text>
                <Text>{authorInfo.hobbies}</Text>
              </div>

              {/* 编辑按钮 */}
              <Space>
                <Button type="primary" icon={<span>✏️</span>} onClick={handleEdit}>
                  编辑个人信息
                </Button>
              </Space>
            </div>
          </div>
        </Card>
      </Content>

      <AppFooter />

      {/* 编辑个人信息弹窗 */}
      <Modal
        title="编辑个人信息"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>取消</Button>,
          <Button key="submit" type="primary" onClick={() => form.submit()}>确定</Button>
        ]}
        width={600}
      >
        <Form
          form={form}
          onFinish={handleSubmit}
          labelCol={{ span: 6 }} // 标签宽度
          wrapperCol={{ span: 18 }} // 输入框宽度
          initialValues={authorInfo}
        >
          <Form.Item label="头像(URL)" name="avatarUrl" rules={[{ required: true, message: '请输入头像URL' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="姓名" name="name" rules={[{ required: true, message: '请输入姓名' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="个人简介" name="intro" rules={[{ required: true, message: '请输入个人简介' }]}>
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item label="更详细的介绍" name="detailIntro" rules={[{ required: true, message: '请输入详细介绍' }]}>
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item label="联系邮箱" name="email" rules={[{ required: true, message: '请输入邮箱' }, { type: 'email', message: '请输入正确邮箱格式' }]}>
            <Input />
          </Form.Item>
          <Form.Item label="技术栈" name="techStack">
            <Input />
          </Form.Item>
          <Form.Item label="兴趣爱好" name="hobbies">
            <Input />
          </Form.Item>
          <Form.Item label="GitHub链接" name="github">
            <Input />
          </Form.Item>
          <Form.Item label="个人主页链接(可选)" name="personalLink">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
};

export default About;